<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main">
					<div class="mbxdh">
						<el-breadcrumb separator-class="el-icon-arrow-right">
						  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						  
						  <el-breadcrumb-item v-if="p == 'list_daohang'" :to="{ path: '/daohang'}">成长导航</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="t == '31'" :to="{ path: '/list_daohang?t=31'}">工作导航库</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="t == '33'" :to="{ path: '/list_daohang?t=33'}">企业工具库</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="t == '35'" :to="{ path: '/list_daohang?t=35'}">企业案例库</el-breadcrumb-item>
						  
						  <el-breadcrumb-item v-if="p == 'list_zhichan'" :to="{ path: '/zhichan'}">知识产权</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="t == '41'" :to="{ path: '/list_zhichan?t=41'}">知识产权导航</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="t == '43'" :to="{ path: '/list_zhichan?t=43'}">知识产权工具</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="t == '45'" :to="{ path: '/list_zhichan?t=45'}">知识产权案例</el-breadcrumb-item>
						  
						  <el-breadcrumb-item v-if="p == 'list_fengxian'" :to="{ path: '/fengxian'}">风险管控</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="t == '61'" :to="{ path: '/list_fengxian?t=61'}">风险管控原理</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="t == '63'" :to="{ path: '/list_fengxian?t=63'}">风险管控工具</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="t == '65'" :to="{ path: '/list_fengxian?t=65'}">风险管控案例</el-breadcrumb-item>
						  
						  
						  <el-breadcrumb-item>{{detail.title}}</el-breadcrumb-item>
						  
						</el-breadcrumb>
					</div>
					
					
					<div class="neirong_line">
						<div class="neirong_line_left">
							
							<div class="neirong_line_region">
								<div class="neirong_line_detail_title">
									{{detail.title}}
								</div>
								
								<div class="neirong_line_detail_content" v-if="detail.content.length > 0">
									<p v-html="detail.content"></p>
								</div>
								<div class="neirong_line_detail_content"  v-if="detail.picture.length > 0">
									<iframe :src="detail.picture" width="100%" height="900"></iframe>
								</div>
								
								<div class="neirong_line_detail_content" v-if="detail.content.length == 0 && detail.picture.length == 0">
									<p style="text-align: center;">-</p>
								</div>
								
								<!-- <div class="neirong_line_split"></div> -->
								
								<div class="neirong_line_option" style="padding-top: 8px;" v-if="is_show_attachment">
									<el-row>
										<!-- <el-col :span="4">
											<el-button icon="el-icon-star-off" size="mini"> 加入收藏 </el-button>
										</el-col> -->
										<!-- <el-col :span="4" :offset="16">
											<el-link type="primary"> 查看文件 </el-link>
										</el-col> -->
										<!-- <el-col :span="4" :offset="16">
											<el-button icon="el-icon-link" size="mini" style="float: right;"> 其它链接 </el-button>
										</el-col> -->
										<el-col :span="4" :offset="20">
											<el-button icon="el-icon-download" size="mini" style="float: right;" @click="uDownload(detail.title, detail.attachment)"> 下载附件 </el-button>
										</el-col>
									</el-row>
								</div>
								
							</div>
							
							<!-- <div class="neirong_line_page">
								这里后期可以关联其它跟本文相关的内容或链接
							</div> -->
						</div>
						
						
						<div class="neirong_line_right">
							<AdverRightCus></AdverRightCus>
						</div>
					</div>
					
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	import AdverRightCus from '../components/adverRight.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
			AdverRightCus,
		},
		data() {
			return {
				detail: {
					id: 0,
					content: '',
					picture: '',
				},
				p: '',
				t: '',
				is_show_attachment: false,
			}
		},
		
		created() {
			this.detail.id = this.$route.query.id
			this.p = this.$route.query.p
			this.t = this.$route.query.t
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			
			this.loadDetail()
		},
		
		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					this.$router.push({path: url})
				}
			},
			
			// 加载详情
			loadDetail() {
				let url = this.$common.apiUrl + 'pub_tuwen_base/detail/' + this.detail.id
				this.$axios.get(url).then((res)=>{
					console.log(res.data)
					this.detail = res.data.data
					let url = this.detail.url // 判断是否有url，如果有url则跳转
					if (url.length > 5) {
						this.toUrl(url)
					}
					let attachment = this.detail.attachment
					if (attachment.length > 5) {
						this.is_show_attachment = true
					}
					
					if (this.detail.dictTuwenType == 101) {
						// 单页图文不作处理
					} else {
						// 工具图文，判断用户是否登录
						let cur_user = JSON.parse(localStorage.getItem('cur_user'));
						if (cur_user) {
							
						} else {
							console.log('用户未登录，无法下载')
							this.$message.error('用户未登录，无法继续浏览，请登录会员后浏览和下载')
							setTimeout(() => {
								this.toUrl('/login')
							}, 2500)
						}
					}
				})
			},
			
			// 下载附件
			dlAttachment() {
				let attachment = this.detail.attachment
				// console.log(attachment)
				let arr_attach = attachment.split('profile')
				console.log(arr_attach[1])
				let new_file = this.$common.adimgUrl + 'profile/' + arr_attach[1]
				location.href = new_file
			},
			// 用户点击下载
			uDownload(file_name, file_path) {
				let arr_attach = file_path.split('profile')
				file_path = this.$common.adimgUrl + 'profile/' + arr_attach[1]
				// console.log('用户下载信息：', file_name, file_path)
				let cur_user = JSON.parse(localStorage.getItem('cur_user'));
				if (cur_user) {
					let url = this.$common.apiUrl + 'pub_user_download/add'
					let client_data = this.$qs.stringify({fileName: file_name, filePath: file_path, userId: cur_user.id})
					this.$axios.post(url, client_data).then((res)=>{
						// console.log(res.data)
						if (res.data.msg.indexOf('ERROR') > -1) {
							this.$message.warning(res.data.msg);
						} else {
							//正常下载链接跳转
							window.open(file_path, '_blank')
						}
					})
				} else {
					console.log('用户未登录，无法下载')
					this.$message.error('用户未登录，无法继续浏览，请登录会员后浏览和下载')
					setTimeout(() => {
						this.toUrl('/login')
					}, 2500)
				}
			},
			
			
			
		}
	}
</script>

<style scoped>
</style>